import React from 'react';

// components
import CommonHeader from '../../../../common/components/CommonHeader';
import Feedback from '../Help/components/Feedback';
import FreeComponent from './components/FreeComponent';
import Activated from './components/Activated';

const Pro = () => {
	return (
		<>
			<CommonHeader
				parentSlug="easycommerce"
				parentLavel="EasyCommerce"
				breadcumpSlug="Pro"
			/>

            <div className="mt-[30px] mx-[40px] bg-white max-w-full px-[165px] mb-10 rounded-lg font-inter">
                {EASYCOMMERCE.pro.activated ? (
                    <Activated />
                ) : (
                    <FreeComponent />
                )}
            </div>
		</>
	);
};

export default Pro;
